import React, { Component } from 'react'
import { connect } from 'react-redux'

import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'

import dataActions from 'actions/dataActions'

export class AddButton extends Component{
	state = { isOpen: false }
	toggleMenu = () => {
	    this.setState({
	    	isOpen: !this.state.isOpen
	    })
  	}
	render(){
		let { props } = this
		return(
			<div className="button">
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
				>
					<i
						className="material-icons"
						style={{
							cursor: "pointer"
						  , display: "inline-block"
						  , fontSize: "28px"
						  , marginRight:"5px"
						  , color: "rgb(90, 228, 195)"
						  , float: "left"
						  , marginTop: "-3px"
						}}
					>
						assignment
					</i>
					<span style={{borderBottom: "dotted 2px " +  (props.color || "#5ae4c3")}}>REPORT</span>
				</span>
			</div>
		)
	}
}
export default connect(null, dataActions)(AddButton)



// WEBPACK FOOTER //
// ./src/routes/landlord/dashboard/ReportButton.js